customElements.define(
  'cart-note-attributes-z',
  class CartNoteAttributes extends HTMLElement {
    constructor() {
      super();

      this.trigger = document.querySelector('[data-note-trigger]');
      this.messageOnlyGiftCart = document.querySelector('[data-message-only-gift-card]');
      this.editTrigger = document.querySelector('[data-edit-note]');
      this.panel = document.querySelector('.cart-drawer_note-panel');
      this.cartGiftPanel = document.querySelector('cart-gift-variants-panel-z');
      this.hasAttributes = false;

      this.trigger.addEventListener('change', (event) => {
        event.preventDefault();
        this.checkNote();
      });   

      this.editTrigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleNote();
      });
    }

    async checkGiftCard() {
      let hasOnlyGiftCard = false;
      const cart = await window.cartManager.getCart();
      for (let index = 0; index < cart.items.length; index++) {
        if (cart.items[index].product_id.toString() == "5630945001622") {
          hasOnlyGiftCard = true;
        }
      }
    
      if (hasOnlyGiftCard) {
        this.panel.clearGiftWords();
        this.trigger.checked = false;
        if(this.messageOnlyGiftCart != null) {
          this.messageOnlyGiftCart.classList.remove("hide");
        }
        this.trigger.setAttribute('disabled', '')
      } else {
        if(this.messageOnlyGiftCart != null) {
          this.messageOnlyGiftCart.classList.add("hide");
        }
        this.trigger.removeAttribute('disabled');
      }
    }

    async checkNote() {
      this.hasAttributes = false;
      var trigger = this.trigger;

      if (this.cartGiftPanel != null && this.cartGiftPanel.classList.contains('active')) {
        this.cartGiftPanel.close();
      }

      const cart = await window.cartManager.getCart();
      if (cart.attributes != null && (cart.attributes.gift_card_text1 != null || cart.attributes.gift_card_text2 != null)) {
        this.hasAttributes = true;
      }

      if (this.hasAttributes) {
        this.panel.clearGiftWords();
        if (this.panel.classList.contains('active')) {
          this.panel.classList.remove('active');
          localStorage.setItem('noteClose', true);
          trigger.disabled = 'disabled';
        }
      } else {
        if (this.panel.classList.contains('active')) {
          this.panel.classList.remove('active');
          localStorage.setItem('noteClose', true);
          trigger.disabled = 'disabled';
        } else {
          if (!trigger.checked) {
            this.panel.classList.remove('active');
            localStorage.setItem('noteClose', true);
            trigger.disabled = 'disabled';
          } else {
            if (localStorage.getItem('noteClose') == null) {
              this.panel.classList.add('active');
            }
          }
        }
      }

      setTimeout(function() {
        localStorage.removeItem('noteClose');
        trigger.disabled = false;
      }, 1000);

    }

    toggleNote() {
      if (this.panel.classList.contains('active')) {
        this.panel.classList.remove('active');
      } else {
        this.panel.classList.add('active');
      }
      if (this.cartGiftPanel != null && this.cartGiftPanel.classList.contains('active')) {
        this.cartGiftPanel.close();
      }
    }
  },
);
customElements.define(
  'cart-note-attributes-panel-z',
  class CartNoteAttributesPanel extends HTMLElement {
    constructor() {
      super();

      this.inputs = document.querySelectorAll('.note-input');
      this.button = document.querySelector('[data-add_gift_words_submit]');
      this.counter = document.querySelector('[data-characters-counter]');
      this.editTrigger = document.querySelector('[data-edit-note]');
      this.wordGift = document.querySelector('#words_gift');
      this.wordGiftDestinataire = document.querySelector('#words_gift_destinataire');
      this.error = document.querySelector('[data-add_gift_words-error]');
      this.close = document.querySelector('[data-close-note]');
      this.cartNote = document.querySelector('cart-note-attributes-z');

      this.attributesZ = {
        gift_card_text1: '',
        gift_card_text2: '',
        gift_card_text3: '',
        gift_card_text4: ''
      };

      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateAttibute();
      });
      
      this.close.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.classList.contains('active')) {
          if (this.cartNote != null) {
            if (localStorage.getItem('cartHasAttribute') == null && this.cartNote.trigger.checked) {
              this.cartNote.trigger.click();
            } else {
              this.cartNote.editTrigger.click();
            }
          } 
        }
      });

      if (this.wordGift) {
        this.wordGift.addEventListener('keyup', () => {
          if (this.counter) {
            this.counter.innerHTML = this.wordGift.value.length;
          }
          this.prepareAttributes();
        });
        
        // Séparer correctement les écouteurs d'événements
        this.wordGift.addEventListener('input', () => this.handleMaxLength());
        this.wordGift.addEventListener('focus', () => this.handleMaxLength());
        this.wordGift.addEventListener('keydown', () => this.handleMaxLength());
      }
      
      if (this.wordGiftDestinataire) {
        this.wordGiftDestinataire.addEventListener('keyup', () => {
          this.prepareAttributes();
        });
      }

      this.init();
    }   

    init() {
      if (this.counter && this.wordGift) {
        this.counter.innerHTML = this.wordGift.value.length;
      }
    }
    
    handleMaxLength() {
      const maxLength = 100;
      if (this.wordGift && this.wordGift.value.length > maxLength) {
        this.wordGift.value = this.wordGift.value.substring(0, maxLength);
      }
    }
    
    prepareAttributes() {
      // Ne prépare les attributs que lorsque nécessaire, sans les envoyer
      if (!this.wordGift || !this.wordGiftDestinataire) return;
      
      const notes = [];
      notes.push(this.wordGiftDestinataire.value);
      
      const notesArray = this.wordGift.value.split(/\n/).filter(val => val !== '');
      for (let i = 0; i < notesArray.length; i++) {
        notes.push(notesArray[i]);
      }
      
      const attributes = {};
      for (let i = 0; i < 4; i++) {
        attributes['gift_card_text' + (i+1)] = '';
        if (notes[i]) {
          attributes['gift_card_text' + (i+1)] = notes[i].replace('\t', '').trim();
        }
      }
      
      this.attributesZ = attributes;
    }

    updateAttibute() {
      this.prepareAttributes();
      
      // Vérifier si nous avons au moins deux notes (destinataire + message)
      const hasDestinataire = this.wordGiftDestinataire && this.wordGiftDestinataire.value.trim() !== '';
      const hasMessage = this.wordGift && this.wordGift.value.trim() !== '';
      
      if (!hasDestinataire || !hasMessage) {
        if (this.error) {
          this.error.classList.remove('hide');
        }
        return;
      }
      
      if (this.error) {
        this.error.classList.add('hide');
      }
      
      // Envoyer les attributs uniquement lorsque le bouton est cliqué
      window.cartManager.updateAttibute(this.attributesZ, {
        onSuccess: this.onSuccessUpdated.bind(this),
      });
      
      localStorage.setItem('noteUpdated', true);
      
      setTimeout(() => {
        if (localStorage.getItem('noteUpdated')) {
          localStorage.removeItem('noteUpdated');
        }
      }, 3000);
    }

    onSuccessUpdated() {
      if (this.editTrigger) {
        this.editTrigger.classList.remove('hide');
        this.editTrigger.click();
      }
      
      if (localStorage.getItem('cartHasAttribute') == null) {
        localStorage.setItem('cartHasAttribute', true);
      }
    }

    clearGiftWords() {
      if (this.inputs) {
        this.inputs.forEach(input => {
          input.value = "";
        });
      }

      this.attributesZ = {
        gift_card_text1: '',
        gift_card_text2: '',
        gift_card_text3: '',
        gift_card_text4: ''
      };

      window.cartManager.updateAttibute(this.attributesZ);
      localStorage.setItem('noteUpdated', true);
      
      if (this.editTrigger) {
        this.editTrigger.classList.add('hide');
      }
      
      if (localStorage.getItem('cartHasAttribute') != null) {
        localStorage.removeItem('cartHasAttribute');
      }
      
      setTimeout(() => {
        if (localStorage.getItem('noteUpdated')) {
          localStorage.removeItem('noteUpdated');
        }
      }, 3000);
    }
  },
);

